import Vue from 'vue'
import Vuex from 'vuex'
import DateRange from './DateRange'
import User from './user'
import Client from './client'
import Settings from './settings'
import ClientGroups from './client_groups'
import DashboardData from './dashboard'
import Reports from './reports'
import WidgetTitles from './widget_titles'
import Metric from './metric'

Vue.use(Vuex)

export default new Vuex.Store({

  modules: {
    DateRange,
    User,
    Client,
    Settings,
    ClientGroups,
    DashboardData,
    Reports,
    WidgetTitles,
    Metric
  }

})
